import http from '../httpService';
import {BASE_URL, token} from '../../utils/const';
import * as Axios from 'axios';


export function updateControl(measuresData) {
    return Axios({
        method: 'put',
        url: `/risk-controls`,
        data: measuresData,
        headers: {'Content-Type': 'application/json'}
    });
}

export function addControl(measuresData) {
    return Axios({
        method: 'post',
        url: '/risk-controls',
        data: measuresData,
        headers: {'Content-Type': 'application/json'}
    });
}

